import { get, writable } from 'svelte/store';
import { SlaughterService } from '../../services/slaughter.service';
import { formatDateOnlyISO } from '../../utils/date-utils';
export const loading = writable(false);
export const filter = writable({ criteria: { refDate: formatDateOnlyISO(new Date()) } });
export const records = writable([]);
export const showCompleted = writable(0);
export async function initList() {
    let refDate = formatDateOnlyISO(new Date());
    filter.set({ criteria: { refDate: refDate, showCompleted: get(showCompleted) }, params: null, sorting: "" });
    await load();
}
export async function search() {
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        _filter.criteria.showCompleted = get(showCompleted);
        let _resp = await SlaughterService.getSlaughterIngressItems(_filter);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function saveImmissionWork(item, quantity) {
    let dto = {
        slaughterItemId: item.slaughterItem.oid,
        quantity: quantity
    };
    await SlaughterService.saveSlaughterIngressItemWork(dto);
    await load();
}
export async function saveImmissionSkip(item, quantity) {
    let dto = {
        slaughterItemId: item.slaughterItem.oid,
        quantity: quantity
    };
    await SlaughterService.saveSlaughterIngressItemSkip(dto);
    await load();
}
export function onDateFilterChanged(evt) {
    let date = evt.detail;
    if (!date)
        return;
    let _filter = get(filter);
    filter.set(Object.assign(Object.assign({}, _filter), { criteria: Object.assign(Object.assign({}, _filter.criteria), { refDate: date }) }));
    search();
}
